import React, { useEffect, useState } from "react";
import Modal from "@material-ui/core/Modal";
import { FaCheckCircle, FaTimes, FaCalendarAlt } from "react-icons/fa";

import {
  toDatetimeLocalValue,
  toLocalISOString,
} from "./observationDateUtils";

function ServiceOrderCompleteModal({ show, obs, onHide, onConfirm, t }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) return;
    const startSource =
      (obs && (obs.executed_start_date || obs.start_date)) || new Date();
    const endSource =
      (obs && (obs.executed_end_date || obs.end_date)) || new Date();
    setStartDate(toDatetimeLocalValue(startSource));
    setEndDate(toDatetimeLocalValue(endSource));
    setSubmitting(false);
    setError("");
  }, [show, obs]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!startDate || !endDate) return;
    if (new Date(endDate) <= new Date(startDate)) {
      setError(t("O fim da execução deve ser depois do início."));
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await onConfirm({
        executed_start_date: toLocalISOString(startDate),
        executed_end_date: toLocalISOString(endDate),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal open={!!show} onClose={onHide}>
      <div className="modal-size" style={{ maxWidth: 460 }}>
        <div className="x_title">
          <h5 align="center">
            <FaCheckCircle style={{ marginRight: 6 }} />
            {t("Concluir ordem de serviço")}
          </h5>
          <div className="clearfix" />
        </div>
        <form onSubmit={handleSubmit} style={{ padding: 10 }}>
          <p style={{ marginBottom: 14, color: "#555" }}>
            {t(
              "Informe quando o serviço realmente começou e terminou. O rastreamento usa este período."
            )}
          </p>
          <div className="form-group">
            <label htmlFor="so-complete-start">
              <FaCalendarAlt style={{ marginRight: 5 }} />
              {t("Início da execução")}
            </label>
            <input
              id="so-complete-start"
              type="datetime-local"
              className="form-control"
              value={startDate}
              onChange={(event) => setStartDate(event.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="so-complete-end">
              <FaCalendarAlt style={{ marginRight: 5 }} />
              {t("Fim da execução")}
            </label>
            <input
              id="so-complete-end"
              type="datetime-local"
              className="form-control"
              value={endDate}
              onChange={(event) => setEndDate(event.target.value)}
              required
            />
          </div>
          {error ? <div className="alert alert-danger">{error}</div> : null}
          <div className="text-right" style={{ marginTop: 15 }}>
            <button
              type="button"
              className="btn btn-default"
              onClick={onHide}
              disabled={submitting}
              style={{ marginRight: 8 }}
            >
              <FaTimes style={{ marginRight: 5 }} />
              {t("Cancelar")}
            </button>
            <button
              type="submit"
              className="btn btn-success"
              disabled={submitting || !startDate || !endDate}
            >
              <FaCheckCircle style={{ marginRight: 5 }} />
              {submitting ? t("Concluindo...") : t("Concluir")}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default ServiceOrderCompleteModal;
